import { P0, S, abs, fillAt, limb, quad } from '../../geometry';

export const carrot = {
  name: 'Carrot',
  colors: ['#C46A3E', '#2F9E5B'],
  draw(m, t) {
    let wv = 6,
      sp = 1.4,
      spread = 1,
      tipX = 1.5 * S(t * 1.2),
      lean = 0,
      pose = P0();
    if (m === 'happy') {
      wv = 12;
      sp = 9;
      spread = 1.25;
      pose.ty = -3 * abs(S(t * 6));
    }
    // Thinking: the fronds keep waving one after another, like a crowd doing the wave.
    if (m === 'thinking') {
      wv = 22;
      sp = 3.4;
      tipX = 5 * S(t * 1.7);
      pose.rot = 2 * S(t * 1.7);
    }
    if (m === 'talking') {
      wv = 8;
      sp = 10;
    }
    if (m === 'surprised') {
      wv = 2;
      sp = 24;
      spread = 0.6;
    }
    if (m === 'paused') {
      wv = 3;
      sp = 0.6;
      spread = 2.6;
      tipX = 8;
      lean = 6;
      pose.ty = 2;
    }
    const body = [
      [30, 36],
      ...quad([30, 36], [50, 26], [70, 36], 6).slice(1),
      ...quad([70, 36], [68, 64], [50 + tipX, 89], 6).slice(1),
      ...quad([50 + tipX, 89], [32, 64], [30, 36], 6).slice(1),
    ];
    const fronds = [-1, 0, 1].map((d, i) => {
      const a = -90 + d * 26 * spread + wv * S(t * sp - i * 1.2) + lean,
        l = d ? 17 : 21;
      return {
        c: 'b',
        pts: limb(
          50 + d * 5,
          31,
          a,
          l,
          -d * 3 + wv * 0.25 * S(t * sp - i * 1.2 - 0.8),
          4
        ),
      };
    });
    return {
      strokes: [...fronds, { c: 'a', pts: body, n: 30 }],
      eyes: { x: 50, y: 48 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 3),
};
